import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getUserId, userIsLogged } from '../../../Login/helpers/storage';
import { useActions } from '../../../../hooks/useAction';
import { useTypedSelector } from '../../../../hooks/useTypesSelector';
import { CardsList } from '../cards-list/CardsList';
import { DiffWords } from '../diff-words/DiffWords';
import { SelectPage } from '../select-page/SelectPage';
import { TextbookSections, Navigate } from '../../constants';
import styles from './styles.module.scss';
import { HeaderTextBook } from '../textbook-header/TeaxtBookHeader';
import { GameList } from '../game-list/GameList';

export const Textbook = () => {
  const { fetchWords } = useActions();
  const { isAuthorized } = useTypedSelector((state) => state.auth);
  const userMessage = useTypedSelector((state) => state.auth.user.message);
  const [searchParams, setSearchParams] = useSearchParams();
  const groupParam = searchParams.get('group') ?? '0';
  const group = +groupParam;
  const unitParam = searchParams.get('page') ?? '0';
  const page = +unitParam;
  const userId = getUserId() || '';
  const { fetchUserWords } = useActions();
  const [sectionDisplay, setSectionDisplay] = useState(TextbookSections.TEXTBOOK);

  useEffect(() => {
    if (group === 6) {
      setSectionDisplay(TextbookSections.DIFF_WORDS);
    }
    if (!userIsLogged(userMessage)) {
      fetchWords(group, page);
    }
    if (userIsLogged(userMessage)) {
      fetchUserWords(userId, `${group}`, `${page}`);
    }
  }, [fetchUserWords, fetchWords, group, page, userId, userMessage]);

  // useEffect(() => {
  //   !isAuthorized ? fetchWords(group, page) : null;
  // }, [group, page, isAuthorized]);

  const handlePageNavigate = (navigation: Navigate) => {
    switch (navigation) {
      case Navigate.PREV:
        setSearchParams({ group: `${group}`, page: `${page - 1}` });
        console.log(page);
        break;

      case Navigate.NEXT:
        setSearchParams({ group: `${group}`, page: `${page + 1}` });
        console.log(page);
        break;
    }
  };

  const handleGroupClick = (groupNumber: number) => {
    setSearchParams({ group: `${groupNumber}`, page: `${page}` });
  };

  const handleDisplay = (
    event: React.MouseEvent<HTMLButtonElement> & { target: HTMLButtonElement }
  ) => {
    switch (event.target.name) {
      case TextbookSections.TEXTBOOK:
        setSectionDisplay(() => TextbookSections.TEXTBOOK);
        setSearchParams({ group: `${0}`, page: `${0}` });
        break;
      case TextbookSections.DIFF_WORDS:
        setSectionDisplay(() => TextbookSections.DIFF_WORDS);
        setSearchParams({ group: `${6}`, page: `${0}` });
        break;
    }
  };

  const handlePaginationClick = (pageNumber: number) => {
    setSearchParams({ group: `${group}`, page: `${pageNumber}` });
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          {isAuthorized && (
            <>
              <div className={styles.btn_book}>
                <Button
                  onClick={handleDisplay}
                  name={`${TextbookSections.TEXTBOOK}`}
                  disabled={sectionDisplay === TextbookSections.TEXTBOOK}
                >
                  Учебник
                </Button>
                <Button
                  disabled={sectionDisplay === TextbookSections.DIFF_WORDS}
                  onClick={handleDisplay}
                  name={`${TextbookSections.DIFF_WORDS}`}
                >
                  Сложные слова
                </Button>
              </div>
              <div className={styles.btn_game}>
                <GameList page={page} group={group} />
              </div>
            </>
          )}
        </div>

        {sectionDisplay === TextbookSections.TEXTBOOK ? (
          <>
            <HeaderTextBook
              onPageNavigate={handlePageNavigate}
              onPaginationClick={handlePaginationClick}
              page={page}
              onGroupClick={handleGroupClick}
              group={group}
            />
            <CardsList />
            <SelectPage
              page={page}
              onPageNavigate={handlePageNavigate}
              onPaginationClick={handlePaginationClick}
            />
          </>
        ) : (
          <DiffWords group={group} />
        )}
      </div>
    </>
  );
};
